import React, { useState, useRef,useLayoutEffect,useEffect } from 'react';
//import {useSelector} from "react-redux";
import { Link } from 'react-router-dom';
import { project } from '../../../utils/project';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { HashLink } from 'react-router-hash-link';
import { customShowLoadingLayer, customHideLoadingLayer, showWarningLayer, hideWarningLayer } from '../../../utils/utils';
import * as actionCreators from '../../../redux/login/login.actions';
import { ProjectActionTypes } from '../../../redux/project/project.types';
import Menu from '../menu/menu.component';

import './navbar.styles.scss';


const NavBar = ({ menutype }) => {
  const [width, setWidth] = useState(window.innerWidth);
  const stickyHeader = useRef();
  const xprops = useSelector(state => state);
  const dispatch = useDispatch();
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const handleOpenLogin = () => dispatch(actionCreators.setFormLoginStatus(true));


  const logOut = () => dispatch(actionCreators.userLogout());
  const onWarning = (payload) => {
    dispatch({ type: ProjectActionTypes.SET_WARNING_MESSAGE, payload: payload });
  }

  const handleLogout = (event) => {
    customShowLoadingLayer();
    onWarning({ warningMessageType: 'success', warningMessageText: 'Çıkış yapıldı.' });
    showWarningLayer();
    setTimeout(() => {
      logOut();
      customHideLoadingLayer();
      hideWarningLayer();
    }, 3000);
  }

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
      window.addEventListener('resize', handleWindowSizeChange);
      return () => {
          window.removeEventListener('resize', handleWindowSizeChange);
      }
  }, []);

  const isMobile = width <= 768;


  useLayoutEffect(() => {
    const mainHeader = document.getElementById('navID');
    let fixedTop = mainHeader.offsetTop;
    
    const mainId = document.getElementById('mainID');
    const fixedHeader = () => {
      //console.log(window.pageYOffset);
      if (!isMobile){
        if (window.pageYOffset >= 50) {
          if (menutype !== "nosticky"){
            mainId.style.paddingTop = "100px";
            mainHeader.classList.add('navbarsticky');
          }
  
        } else {
          mainHeader.classList.remove('navbarsticky');
          mainId.style.paddingTop = "0px";
        }
  
      }
    }
    window.addEventListener('scroll', fixedHeader);    
  }, [])  


  return (
    <React.Fragment>
      <nav id="navID" className="navbarhome" ref={stickyHeader}>
        <div className="navbarhome-container">
          <Link to="/" className="logoContainer">
            <img className="navbarhome-logo" src={process.env.PUBLIC_URL + '/assets/images/logo.png'} alt={project.projectName} />
          </Link>
          <div className="menu-icon" onClick={handleClick}>
            <i className={click ? 'fas' : 'fas fa-bars'} />
          </div>
          <ul className={click ? 'nav-menu active' : 'nav-menu'}>

            {
              click &&
              <button className="navmenuCloseBtn" onClick={closeMobileMenu}></button>
            }

            <li className="nav-item-main">
              <Link
                to='/uzman-bul'
                className='nav-links-main'
                onClick={closeMobileMenu}
              >
                UZMAN BUL
              </Link>
            </li>
            <li className="nav-item-main">
              <Link
                to='/hakkimizda'
                className='nav-links-main'
                onClick={closeMobileMenu}
              >
                HAKKIMIZDA
              </Link>
            </li>
            <li className="nav-item-main">
              <Link
                to='/blog'
                className='nav-links-main'
                onClick={closeMobileMenu}
              >
                BLOG
              </Link>
            </li>
            <li className="nav-item-main">
              <Link
                to='/egitimler'
                className='nav-links-main'
                onClick={closeMobileMenu}
              >
                EĞİTİMLER
              </Link>
            </li>
            <li className="nav-item-main">
              <Link
                to='/toplantilar'
                className='nav-links-main'
                onClick={closeMobileMenu}
              >
                TOPLANTILAR
              </Link>
            </li>
            <li className="nav-item-main">
              <Link
                to='/farkindalik-calismalari'
                className='nav-links-main'
                onClick={closeMobileMenu}
              >
                FARKINDALIK ÇALIŞMALARI
              </Link>
            </li>
            <li className="nav-item-main">
              <Link
                to='/mentorluk'
                className='nav-links-main'
                onClick={closeMobileMenu}
              >
                MENTORLUK
              </Link>
            </li>
            <li className="nav-item-main">
              <Link
                to='/iletisim'
                className='nav-links-main'
                onClick={closeMobileMenu}
              >
                İLETİŞİM
              </Link>
            </li>
            {
              xprops.login.isLoggedIn === true ?
                <React.Fragment>
                  <li className="nav-item-main">
                    <Link
                      to='/profil'
                      className='nav-links-main'
                      onClick={closeMobileMenu}
                    >
                      BİLGİLERİM
                    </Link>
                  </li>
                </React.Fragment>
                :
                <React.Fragment>
                  <li className="nav-item-main">
                    <Link
                      to='/signup'
                      className='nav-links-main'
                      onClick={closeMobileMenu}
                    >
                      KATILIM
                    </Link>
                  </li>
                  <React.Fragment>
                    <Link
                      to='/giris'
                      className='nav-links-main'
                      onClick={closeMobileMenu}
                    >
                      GİRİŞ
                    </Link>
                  </React.Fragment>
                </React.Fragment>
            }

            {
              xprops.login.isLoggedIn === true &&
              <React.Fragment>
                <li className="nav-item-main" onClick={handleLogout}>
                  <span className="nav-links-main">ÇIKIŞ</span>
                </li>
              </React.Fragment>
            }


          </ul>
          <div className="mainMenuWrapper">
            <Menu /> 
            {
              menutype !== "nosticky" &&
                <ul className={click ? 'nav-menu-sub active' : 'nav-menu-sub'}>
                {
                  xprops.login.isLoggedIn === true ?
                    <React.Fragment>
                      <li className="nav-item-sub"><Link to='/profil' className="linka">{xprops.project.language.keywords.profile}</Link></li>
                      <li className="nav-item-sub-right"><button className="btnSignout" onClick={handleLogout}>ÇIKIŞ</button></li>           
                    </React.Fragment>
                    :
                    <React.Fragment>
                      <li className="nav-item-sub"><Link to='/giris' className="linka">{xprops.project.language.keywords.signIn}</Link></li>
                    </React.Fragment>
                }
              </ul>      
            }
            {
              menutype === "show" &&
                <ul className={click ? 'nav-menu-sub active' : 'nav-menu-sub'}>
                {
                  xprops.login.isLoggedIn === true ?
                    <React.Fragment>
                      <li className="nav-item-sub"><Link to='/profil' className="linka">{xprops.project.language.keywords.profile}</Link></li>
                    </React.Fragment>
                    :
                    <React.Fragment>
                      {/* <li className="nav-item-sub"><Link to='/giris' className="linka">{xprops.project.language.keywords.signIn}</Link></li> */}
                      {
                        xprops.login.isLoggedIn === true ?
                        <React.Fragment>
                          <li className="nav-item-sub-right">{xprops.login.username} HOŞGELDİNİZ! | <button className="btnSignout" onClick={handleLogout}>ÇIKIŞ</button></li>           
                        </React.Fragment>
                        :
                        <React.Fragment>
                          {/* <li className="nav-item-sub-right"><Link to='/signup' className="linka" >{xprops.project.language.keywords.signUp}</Link></li> */}
                        </React.Fragment>
                      }                
                    </React.Fragment>
                }
                <li className="nav-item-sub langbg ">EN</li>
              </ul>      
            }            
                   

          </div>
       
        </div>

              
      </nav>
      {/* <div className="menu-icon" onClick={handleClick}>
        <i className={click ? 'fas' : 'fas fa-bars'} />
      </div> */}

    </React.Fragment>
  )
};


export default NavBar;

